import { CustomDialog } from '../../components/CustomDialog';
import { useState } from 'react';
import {
  AutoCompleteController,
  Button,
} from '../../components';
import UploadButton from '../../components/uploadButton';
import importFormat from '../../assets/importFormats/commission-import-file-format.xlsx';
import { downLoadLink } from '../../utils/functions/common';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import * as yup from 'yup';
import { useGetAllEnterpriseQuery } from '../../services/common';
import { useCommissionImportMutation } from '../../services/commission';

const formSchema = yup.object({
  enterprise: yup.number().required(),
});
type TFormData = yup.InferType<typeof formSchema>;

export const ImportCommissions: React.FC = () => {
  const { data: listOfEnterprises } =
    useGetAllEnterpriseQuery([1]);
  const formattedListOfEnterprises = listOfEnterprises?.map(
    (ele) => ({
      value: ele.id,
      label: ele.companyName,
    })
  );

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File>();
  const [importCommissions] = useCommissionImportMutation();

  const onImportClick = (formData: TFormData) => {
    const data = new FormData();
    data.append('file', uploadedFile as File);
    importCommissions({
      data,
      enterpriseId: formData.enterprise,
    })
      .unwrap()
      .then((res) => {
        res.reportUrl && downLoadLink(res.reportUrl);
        dispatch(
          showAlert({
            content: res.message,
            severity: res.success ? 'success' : 'error',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-2"
        variant="button--secondary">
        Import
      </Button>
      <CustomDialog
        dialogTitle="Commission Import"
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit((data) =>
          onImportClick(data)
        )}
        actionText={{ submit: 'Import', cancel: 'Cancel' }}
        maxWidth="sm"
        disableAccept={!uploadedFile}>
        <>
          <div>
            {`Please download the commission import format`}{' '}
            <a
              className="link-color"
              href={importFormat}
              download="import_format">
              here
            </a>
          </div>
          <form
            onSubmit={handleSubmit((data) =>
              onImportClick(data)
            )}>
            <AutoCompleteController
              label="Enterprise"
              name="enterprise"
              control={control}
              options={formattedListOfEnterprises}
              error={errors.enterprise?.message}
              required
            />
          </form>
          <UploadButton
            className="mt-6 mb-2"
            handleFile={setUploadedFile}
            allowedMediaTypes=".xlsx"
          />
        </>
      </CustomDialog>
    </>
  );
};
